import React from "react";
import { useCurrentLanguage } from "../../../hooks/useCurrentLanguage";
import ReactPlayer from "react-player";
import "./PNUDVideoCard.css";

export default function PNUDVideoCard({ name, fileName, thumbnail, code }) {
  const { language } = useCurrentLanguage();

  return (
    <div className="pnud-vc-container">
      <p>{name[language]}</p>
      <div style={{ marginBottom: "10px" }}>
        <ReactPlayer
          width={"400px"}
          height={"230px"}
          controls={true}
          muted={true}
          volume={0.8}
          loop={false}
          light={
            thumbnail
              ? require("./../../../images/videoThumbnails/" + code + ".png")
              : false
          }
          playing={thumbnail ?? false}
          //url={"pnud/" + fileName}
          url={fileName}
        />
      </div>
    </div>
  );
}
